var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineUpIcehockeyGoal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.6916 0 0 1.19609 0 2.66594C0 4.13578 2.6916 5.33241 6 5.33241C9.3084 5.33241 12 4.13578 12 2.66594C12 1.19609 9.3078 0 6 0Z",
    fill: "#888B8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.55859C11.4078 4.8462 8.9424 5.8141 6 5.8141C3.0576 5.8141 0.5922 4.8462 0 3.55859V5.27267C0 6.77816 2.6916 8.00227 6 8.00227C9.3084 8.00227 12 6.77816 12 5.27267V3.55859Z",
    fill: "#606467"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineUpIcehockeyGoal);
export default __webpack_public_path__ + "static/media/line_up_icehockey_goal.8549ac95a143a3788758876cb87e3cd6.svg";
export { ForwardRef as ReactComponent };